module.exports = __webpack_public_path__ + "img/hw-s7.6d81a43c.svg";